
import Api from '../classes/api';
import Lang from '../classes/lang';
import Logger from '../classes/logger';
import Config from '../classes/config';
import merge from 'lodash.merge';
import AppConfig from '../AppConfig';
import VersionAppConfig from '@active-version/AppConfig';

export const appConfig = new Config(merge({}, AppConfig, VersionAppConfig));
export const api = new Api();
export const lang = new Lang(api);
export const logger = new Logger();
